import React, { useState } from 'react';
import { useGetPriceHistoryBatchIdsQuery, useUpdateLatestFlagsMutation } from '../../../../../reducers/priceHistoryApi';
import { toast } from 'react-toastify';
import styles from './batch-update.module.css';

const BatchUpdateDrawerContent = ({ onClose }) => {
    const { data: batchData, isLoading: isBatchLoading } = useGetPriceHistoryBatchIdsQuery();
    const [updateLatest, { isLoading: isUpdating }] = useUpdateLatestFlagsMutation();
    const [selectedBatchId, setSelectedBatchId] = useState("");

    const handleUpdate = async () => {
        if (!selectedBatchId) {
            toast.error("Please select a Batch ID");
            return;
        }

        try {
            const res = await updateLatest({ batchId: selectedBatchId }).unwrap();
            if (res.success) {
                toast.success(res.message || "Latest flags updated successfully");
                onClose();
            } else {
                toast.error(res.message || "Failed to update latest flags");
            }
        } catch (err) {
            toast.error(err?.data?.message || "An error occurred during update");
        }
    };

    if (isBatchLoading) {
        return (
            <div className={styles.loadingWrapper}>
                <div className="spinner-border text-primary mb-2" role="status"></div>
                <span>Loading Batch IDs...</span>
            </div>
        );
    }

    return (
        <div className={styles.container}>
            <h2 className={styles.title}>Update Latest Price History</h2>
            <p className={styles.subtitle}>Select a batch ID to update the latest pricing flags for all associated products.</p>

            <div className={styles.formGroup}>
                <label className={styles.label}>Batch ID</label>
                <select 
                    className={styles.select}
                    value={selectedBatchId}
                    onChange={(e) => setSelectedBatchId(e.target.value)}
                >
                    <option value="">Select a Batch ID</option>
                    {batchData?.data?.map((batch) => (
                        <option key={batch} value={batch}>
                            {batch}
                        </option>
                    ))}
                </select>
            </div>

            <div className={styles.footer}>
                <button 
                    className={styles.cancelBtn}
                    onClick={onClose}
                    disabled={isUpdating}
                >
                    Cancel
                </button>
                <button 
                    className={styles.submitBtn}
                    onClick={handleUpdate}
                    disabled={isUpdating || !selectedBatchId}
                >
                    {isUpdating ? "Updating..." : "Update Latest Flags"}
                </button>
            </div>
        </div>
    );
};

export default BatchUpdateDrawerContent;
